import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-dona',
  templateUrl: './dona.component.html',
  styles: []
})
export class DonaComponent implements OnInit {

  public fileError: string = '';
  public chartVisible: boolean = true;  // Controls *ngIf on canvas to force full redraw

  public doughnutChartLabels: string[] = [
    'Download Sales',
    'In-Store Sales',
    'Mail-Order Sales'
  ];
  public doughnutChartData: number[] = [350, 450, 100];
  public doughnutChartType: string = 'doughnut';

  constructor() {}
  ngOnInit(): void {}

  public chartClicked(e: any): void { console.log(e); }
  public chartHovered(e: any): void { console.log(e); }

  /** Destroys and recreates the canvas with new data to avoid Chart.js ghost sectors */
  private updateChart(labels: string[], data: number[]): void {
    // Hide canvas → Angular removes it from DOM → Chart.js instance destroyed
    this.chartVisible = false;
    setTimeout(() => {
      this.doughnutChartLabels = labels;
      this.doughnutChartData   = data;
      // Show canvas → Angular recreates it → Chart.js draws from scratch
      this.chartVisible = true;
    }, 0);
  }

  public numeros_random(): void {
    this.updateChart(
      ['Segmento 1', 'Segmento 2', 'Segmento 3'],
      [
        Math.round(Math.random() * 100),
        Math.round(Math.random() * 100),
        Math.round(Math.random() * 100)
      ]
    );
  }

  /**
   * Formato esperado (hoja "Dona" o primera hoja):
   *
   * FORMATO VERTICAL — 2 columnas (recomendado):
   *   Fila 1: Categoría        | Valor   ← cabecera (col B no es número → se omite)
   *   Fila 2: Download Sales   | 420
   *   Fila 3: In-Store Sales   | 310
   *   Fila 4: Mail-Order Sales | 180
   *
   * FORMATO HORIZONTAL:
   *   Fila 1: Download Sales | In-Store Sales | Mail-Order Sales
   *   Fila 2: 420            | 310            | 180
   */
  public loadFromExcel(event: any): void {
    this.fileError = '';
    const file = event.target.files[0];
    if (!file) { return; }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });

        const sheetName =
          workbook.SheetNames.find(n => n.toLowerCase() === 'dona') ||
          workbook.SheetNames[0];

        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          defval: ''
        }) as any[][];

        if (rows.length < 2) {
          this.fileError = 'El archivo debe tener al menos 2 filas.';
          return;
        }

        const firstRow  = rows[0];
        const secondRow = rows[1];

        // If col B of row 1 is NOT a number → vertical format (col A = label, col B = value)
        const firstRowSecondIsNumeric =
          firstRow[1] !== '' && !isNaN(Number(firstRow[1]));

        let newLabels: string[] = [];
        let newData:   number[] = [];

        if (!firstRowSecondIsNumeric) {
          // FORMATO VERTICAL: keep only rows where col A is text AND col B is a valid number
          const dataRows = rows.filter(row => {
            const lbl = String(row[0] !== null && row[0] !== undefined ? row[0] : '').trim();
            const val = Number(row[1]);
            return lbl !== '' && row[1] !== '' && !isNaN(val) && isNaN(Number(lbl));
          });

          if (dataRows.length === 0) {
            this.fileError = 'No se encontraron datos válidos (formato vertical).';
            return;
          }

          newLabels = dataRows.map(row => String(row[0]));
          newData   = dataRows.map(row => Number(row[1]));

        } else {
          // FORMATO HORIZONTAL: row 1 = labels, row 2 = values
          newLabels = firstRow.filter((v: any) => v !== '').map(String);
          newData   = secondRow
            .slice(0, newLabels.length)
            .map((v: any) => Number(v) || 0);
        }

        if (newLabels.length === 0 || newData.length === 0) {
          this.fileError = 'No se encontraron datos válidos.';
          return;
        }

        this.updateChart(newLabels, newData);

      } catch (err) {
        this.fileError = 'Error al leer el archivo Excel.';
        console.error(err);
      }
    };

    reader.readAsBinaryString(file);
    event.target.value = '';
  }
}